export const MeetingState_Expert_Payment = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/expert/payment.html';
    },
];
